import { FormattedMessage } from "react-intl";
const employment = [
  {
    value: "Regular/Permanent",
    label: "RECRUITER.POSTJOB.ADDJOBDETAILS.INPUT.EMPTYPE.REGULAR",
  },
  {
    value: "PartTime",
    label: "RECRUITER.POSTJOB.ADDJOBDETAILS.INPUT.EMPTYPE.PARTTIME",
  },
  {
    value: "Contractual/Temporary",
    label: "RECRUITER.POSTJOB.ADDJOBDETAILS.INPUT.EMPTYPE.CONTRACTUAL",
  },
];

const Schedule = [
  {
    value: "morningshift",
    label: "RECRUITER.POSTJOB.ADDJOBDETAILS.INPUT.SCHEDULE.MORNINGSHIFT",
  },
  {
    value: "rotationshift",
    label: "RECRUITER.POSTJOB.ADDJOBDETAILS.INPUT.SCHEDULE.ROTATIONALSHIFT",
  },
  {
    value: "nightshift",
    label: "RECRUITER.POSTJOB.ADDJOBDETAILS.INPUT.SCHEDULE.NIGHTSHIFT",
  },
  {
    value: "mondaytofriday",
    label: "RECRUITER.POSTJOB.ADDJOBDETAILS.INPUT.SCHEDULE.MONDAYTOFRIDAY",
  },
  {
    value: "eveningshift",
    label: "RECRUITER.POSTJOB.ADDJOBDETAILS.INPUT.SCHEDULE.EVENINGSHIFT",
  },
  {
    value: "weekendavailability",
    label: "RECRUITER.POSTJOB.ADDJOBDETAILS.INPUT.SCHEDULE.WEEKENDAVAILABILITY",
  },
  {
    value: "fixedshift",
    label: "RECRUITER.POSTJOB.ADDJOBDETAILS.INPUT.SCHEDULE.FIXEDSHIFT",
  },
  {
    value: "weekendonly",
    label: "RECRUITER.POSTJOB.ADDJOBDETAILS.INPUT.SCHEDULE.WEEKENDONLY",
  },
];

const supplementalpaydata = [
  {
    value: "performance_bonus",
    label:
      "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.SUPPLEMENTALPAY.PERFORMANCE_BONUS",
  },
  {
    value: "yearly_bonus",
    label: "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.SUPPLEMENTALPAY.YEARLY_BONUS",
  },
  {
    value: "commission_pay",
    label:
      "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.SUPPLEMENTALPAY.COMMISSION_PAY",
  },
  {
    value: "overtime_pay",
    label: "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.SUPPLEMENTALPAY.OVERTIME_PAY",
  },
  {
    value: "quarterly_bonus",
    label:
      "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.SUPPLEMENTALPAY.QUARTERLY_BONUS",
  },
  {
    value: "shift_allowance",
    label:
      "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.SUPPLEMENTALPAY.SHIFT_ALLOWANCE",
  },
  {
    value: "joining_bonus",
    label:
      "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.SUPPLEMENTALPAY.JOINING_BONUS",
  },
  {
    value: "other",
    label: "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.SUPPLEMENTALPAY.OTHER",
  },
];

const benifitdata = [
  {
    value: "healthinsurance",
    label: "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.BENEFITS.HEALTH_INSURANCE",
  },
  {
    value: "providentfund",
    label: "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.BENEFITS.PROVIDENT_FUND",
  },
  {
    value: "cellphonereimbursement",
    label:
      "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.BENEFITS.CELL_PHONE_REIMBURSEMENT",
  },
  {
    value: "paidsicktime",
    label: "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.BENEFITS.PAID_SICK_TIME",
  },
  {
    value: "paidtimeoff",
    label: "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.BENEFITS.PAID_TIME_OFF",
  },
  {
    value: "foodprovided",
    label: "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.BENEFITS.FOOD_PROVIDED",
  },
  {
    value: "lifeinsurance",
    label: "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.BENEFITS.LIFE_INSURANCE",
  },
  {
    value: "internetreimbursement",
    label:
      "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.BENEFITS.INTERNET_REIMBURSEMENT",
  },
  {
    value: "commuterassistance",
    label: "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.BENEFITS.COMMUTER_ASSISTANCE",
  },
  {
    value: "leaveencashment",
    label: "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.BENEFITS.LEAVE_ENCASHMENT",
  },
  {
    value: "flexibleschedule",
    label: "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.BENEFITS.FLEXIBLE_SCHEDULE",
  },
  {
    value: "other",
    label: "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.BENEFITS.OTHER",
  },
];
export { employment, Schedule, supplementalpaydata, benifitdata };
